import {Slider} from './Slider.js';

export class NewsSliderClass {
    constructor(slider) {
        this.slider = slider;
        if (!this.slider) {
            return;
        }

        // Reuse the shared slider engine as the source of truth. Swiper's a11y and
        // pagination modules handle bullet generation, aria-labels, aria-current and
        // the disabled-arrow states automatically, so no custom code is needed here.
        this.swiper = new Slider(this.slider, JSON.stringify({
            slidesPerView: {xs: 1, sm: 1, md: 2, lg: 3, xl: 4},
            spaceBetween: 20,
            rewind: true,
            arrows: 'overlay',
            bullets: 'below',
        }));
    }
}

document.querySelectorAll('[data-news-slider]').forEach((item) => {
    new NewsSliderClass(item);
});
